import { PRODUCT_CONFIG } from "@stb/product-config"

/** Trial length in days for marketing copy; the one number lives in `@stb/product-config` (T1340). */
export const TRIAL_DAYS = PRODUCT_CONFIG.trial.days
